export const ListsStore = {
  userRoles: [{
    id: 'principal',
    label: 'Principal',
    ledesCodes: {
      ledes1998: 'PT',
      ledesXml2: 'PARTNR'
    },
    description: 'A principal is typically a managing partner or a partner in a firm. They will have access to billing information and reporting for {matter}s. They will also have access to the overall financials for the firm.'
  }, {
    id: 'lead',
    label: '{Lead}',
    ledesCodes: {
      ledes1998: 'AS',
      ledesXml2: 'ASSOC'
    },
    description: '{Lead}s can be associates or partners at a firm. They will have access to billing information and reporting for {matter}s they are involved with, but not for the firm as a whole.'
  }, {
    id: 'paralegal',
    label: 'Paralegal',
    ledesCodes: {
      ledes1998: 'PL',
      ledesXml2: 'PARALG'
    },
    description: 'They will have access to billing information and reporting for {matter}s they are involved with, but not for the firm as a whole.'
  }, {
    id: 'operator',
    label: 'Operator',
    ledesCodes: {
      ledes1998: 'OT',
      ledesXml2: 'CLKSEC'
    },
    description: 'An operator is typically business managers, bookkeepers, or assistants of a firm. They will have access to all billing information but will not normally be responsible for {matter}s.'
  }, {
    id: 'accountant',
    label: 'Accountant',
    ledesCodes: {
      ledes1998: '-',
      ledesXml2: '-'
    },
    description: 'Accountants have access to all billing information for the firm.'
  }, {
    id: 'timekeeper',
    label: 'Time Keeper',
    ledesCodes: {
      ledes1998: 'OT',
      ledesXml2: 'NBOTHR'
    },
    description: 'A time keeper does not have access to rates, billing information, and reporting. This is typically associates, contractors, or staff.'
  }],
  matterRoles: [{
    id: 'primary',
    label: `Responsible {Lead}`
  }, {
    id: 'responsible',
    label: `{Lead}`
  }, {
    id: 'paralegal',
    label: 'Paralegal'
  }, {
    id: 'operator',
    label: 'Operator'
  }, {
    id: 'other',
    label: 'Time Keeper'
  }]
};
export default class ListsService {
  constructor() {
    this.billingTypes = [{
      id: 'hours',
      label: 'Hourly',
      description: 'Time is billed hourly by default. Fixed fees and non-billable hours can still be added.'
    }, {
      id: 'contingency',
      label: 'Contingency',
      description: 'Time is marked as non-billable by default. Hourly billed time and fixed fees can still be added.'
    }, {
      id: 'fixed',
      label: 'Fixed Fee',
      description: 'Time is marked as included in the fixed fee by default. Hourly billed time can still be added.'
    }, {
      id: 'none',
      label: 'Pro Bono',
      description: 'Time is marked as non-billable by default. Hourly billed time and fixed fees can still be added.'
    }, {
      id: 'internal',
      label: 'Internal',
      description: 'Time can only be non-billable and will be hidden from most billing filters.'
    }];
    this.recurringPeriods = [{
      id: 'day',
      label: 'Daily'
    }, {
      id: 'week',
      label: 'Weekly'
    }, {
      id: 'month',
      label: 'Monthly'
    }, {
      id: 'quarter',
      label: 'Quarterly'
    }, {
      id: 'year',
      label: 'Yearly'
    }];
    this.entryBillingTypes = [{
      id: 'billable',
      value: 'billable',
      label: 'Billable'
    }, {
      id: 'nonBillable',
      value: 'nonBillable',
      label: 'Non-Billable'
    }, {
      id: 'fixedFee',
      value: 'fixedFee',
      label: 'Fixed Fee'
    }];
    this.distributionStatuses = [{
      id: 'notInDistribution',
      label: 'Not in Distribution'
    }, {
      id: 'draft',
      label: 'Draft'
    }, {
      id: 'distributed',
      label: 'Distributed'
    }];
    this.paymentStatues = [{
      id: 'notInDistribution',
      label: 'Not in Distribution'
    }, {
      id: 'draft',
      label: 'Draft'
    }, {
      id: 'distributed',
      label: 'Distributed'
    }, {
      id: 'partiallyAssigned',
      label: 'Partially Assigned'
    }, {
      id: 'partiallyDistributed',
      label: 'Partially Distributed'
    }];
    this.billedOptions = [{
      label: 'Billed',
      id: 'Final'
    }, {
      label: 'Draft',
      id: 'Interim'
    }, {
      label: 'WIP',
      id: 'WIP'
    }, {
      label: 'Not Billed',
      id: 'notFinal'
    }, {
      label: 'All',
      id: 'all'
    }];
    this.quickBooksStatuses = [{
      id: 'good',
      label: 'Good connection to QuickBooks'
    }, {
      id: 'bad',
      label: 'Bad connection to QuickBooks'
    }, {
      id: 'none',
      label: 'Not connected to QuickBooks'
    }];
  }
  billingTypeFromId(id) {
    return this.findLabel(this.billingTypes, id);
  }
  matterRoleFromId(id) {
    return this.findLabel(this.matterRoles, id);
  }
  userRoleFromId(id) {
    return this.findLabel(this.userRoles, id);
  }
  recurringPeriodFromId(id) {
    return this.findLabel(this.recurringPeriods, id);
  }
  distributionStatusesFromId(id) {
    return this.findLabel(this.distributionStatuses, id);
  }
  quickBooksStatusesFromId(id) {
    return this.findLabel(this.quickBooksStatuses, id);
  }
  authLabel(provider) {
    if (provider === 'Local') {
      return 'LeanLaw Password';
    }
    if (provider === 'Azure') {
      return 'Office 365';
    }
    if (provider === 'Intuit') {
      return 'QuickBooks';
    }
    return provider;
  }
  adjustTerms(me) {
    this.adjust(this.userRoles, me);
    this.adjust(this.matterRoles, me);
  }
  adjust(list, me) {
    list.forEach(item => {
      this.replaceTerms(item, 'label', me);
      this.replaceTerms(item, 'description', me);
    });
  }
  replaceTerms(item, prop, me) {
    if (!item[prop]) return;
    item[prop] = item[prop].replace(/\{(.*?)\}/g, (match, capture) => me.terms[capture]);
  }
  findLabel(list, id) {
    const item = list.find(t => t.id === id);
    return item ? item.label : null;
  }
  get userRoles() {
    return ListsStore.userRoles;
  }
  getUserRoles(ledesVersion = 'ledes1998') {
    // mapping to include only roles with a specified ledes code
    return ListsStore.userRoles.map(role => ({
      id: role.id,
      label: role.label,
      ledes: role.ledesCodes[ledesVersion],
      description: role.description
    })).filter(role => role.ledes);
  }
  get matterRoles() {
    return ListsStore.matterRoles;
  }
}